import type { Shape } from "@/telestrations/types/canvas";

/*
  * Returns the parameters for a rectangle or square (if isSquare=true),
  * builds a shape from the start point in the direction of drag
  * offset - offset for supporting drag inside canvas.
*/
export function getRectangleUpdate({
  shape,
  pointer,
  isSquare = false,
  offset = { x: 0, y: 0 },
}: {
  shape: Shape;
  pointer: { x: number; y: number };
  isSquare?: boolean;
  offset?: { x: number; y: number };
}): Partial<Shape> {
  const dx = pointer.x - shape.startX;
  const dy = pointer.y - shape.startY;

  let width = Math.abs(dx);
  let height = Math.abs(dy);

  if (isSquare) {
    const size = Math.max(width, height);
    width = size;
    height = size;
  }

  const x = (dx >= 0 ? shape.startX : shape.startX - width) + offset.x;
  const y = (dy >= 0 ? shape.startY : shape.startY - height) + offset.y;

  return {
    x,
    y,
    width,
    height,
  };
}
